// Format exact decimal strings without losing large integer precision.
export function formatAccountPoints(value: string) {
  const negative = value.startsWith('-');
  const [whole, fraction = ''] = value.replace(/^-/, '').split('.');
  const decimals = fraction.replace(/0+$/, '');
  return (
    (negative ? '-' : '') +
    new Intl.NumberFormat('en-US').format(BigInt(whole)) +
    (decimals ? '.' + decimals : '')
  );
}
